<template>
    <div>
        <div class="table-area" style="margin-top: 0px;">
            <appr-header :doc-type="docType" :apprHeader="apprHeader" :appr-line="apprLine" :refer-line="referLine" v-model="data"/>
        </div>
        <!-- //Appr Header area -->
        <visit-short v-model="data" :readonly="true" @input="queryApprLineRule"/>
    </div>
</template>

<script>
    import DhxGrid from '@/components/DhxGrid.vue'
    import ApprHeader from '@/components/ApprHeader.vue'
    import ApprLineSet from '@/components/ApprLineSet.vue'

    // Visit Short
    import VisitShort from '@/components/visit/VisitShort.vue'

    export default {
        props: {
            title: {
                type: String,
                required: false,
                default: '결재 상신'
            },
            docMngNo: {
                type: String,
                required: false
            },
            value: {
                type: Object,
                required: false
            },
            docType: {
                type: String,
                required: false,
                default: 'SLIP'
            },
            approvalLine: {
                type: Array,
                required: true
            },
            referenceLine: {
                type: Array,
                required: false
            }
        },
        components: {
            DhxGrid,
            ApprHeader,
            ApprLineSet,
            VisitShort
        },
        data() {
            return {
                apprHeader: {},
                apprLine: [],
                referLine: [],
                apprNo: '',
                apprSeq: '',
                docTitleNm: '',
                docTypeCd: '',
                docStatus: '',
                draftUserId: '',
                thisApprUser: '',
                deleYn: 'N',
                loaded: false,
                data: {},
                deleInfo: {},
            }
        },
        computed: {
            docComponent() {
                switch (this.docType) {
                    case 'SHORT':
                        return 'VisitShort'
                    case 'LONG':
                        return 'VisitLong'
                    default:
                        return undefined
                }
            }
        },
        methods: {
            /**
             * Query Approval line rule
             */
            queryApprLineRule() {
                let docTypeCd = this.docType

                this.$store.commit('loading')
                this.$http.get('/api/appr/rule', {
                    params: {docTypeCd}
                }).then(response => {
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        this.apprLine = response.data.filter(x => x.aprverUser)
                    }
                }).finally(() => {
                    this.apprLine.unshift(
                        {
                            aprverUser: this.$store.state.loginInfo.userName,
                            jobNm: this.$store.state.loginInfo.loginJobNm,
                            aprverId: this.$store.state.loginInfo.loginId,
                            deptNm: this.$store.state.loginInfo.loginDeptNm,
                            apprTypeCd: '10',
                            apprType: '기안'
                        }
                    );

                    this.$emit('approvalLine', this.apprLine)
                    this.$store.commit('finish')
                })

                this.$http.get('/api/refer/rule', {
                    params: {docTypeCd}
                }).then(response => {
                    if (Array.isArray(response.data) && response.data.length > 0) {
                      this.referLine = response.data.filter(x => x.referUser)
                    }
                }).finally(() => {
                    this.$emit('referenceLine', this.referLine)
                })

            },
            approval() {
            },
            getAppr(docMngNo) {
                this.$http.get(`/api/appr/detail/${docMngNo}`)
                    .then(response => {
                        if (response.data) {

                            this.apprSeq = ''
                            this.thisApprUser = ''
                            this.apprHeader = response.data.apprHeader[0];
                            this.apprLine = response.data.apprDetails;
                            this.referLine = response.data.referDetails;

                            this.docTypeCd = response.data.apprHeader[0].docTypeCd;
                            this.docStatus = response.data.apprHeader[0].docStatCd;
                            this.draftUserId = response.data.apprHeader[0].draftUserId;
                            this.docTitleNm = response.data.apprHeader[0].docTitleNm;
                            this.apprNo = response.data.apprHeader[0].apprNo;

                            _.forEach(this.apprLine, v => {
                                if (v.apprFgCd === 'X') {
                                    this.apprSeq = v.apprSeq
                                    this.thisApprUser = v.aprverId
                                    return false
                                }
                            })

                            this.loaded = true

                            this.$emit('approvalLine', this.apprLine)
                            this.$emit('referenceLine', this.referLine)
                        }
                    })
                    .catch(({message}) => {
                        console.error(message);
                    })
            },
            apprCheck() {
                this.$http.get(`/api/appr/delegatingCheck`, {
                    params: {
                        adlgId: this.thisApprUser,
                        actId: this.$store.state.loginInfo.loginId
                    }
                })
                    .then(response => {
                        this.deleYn = response.data;

                        this.apprInfo = {
                            "deleYn": this.deleYn,
                            "apprSeq": this.apprSeq,
                            "thisApprUser": this.thisApprUser,
                            "docStatus": this.docStatus,
                            "draftUserId": this.draftUserId,
                            "docTitleNm": this.docTitleNm,
                            "apprNo": this.apprNo
                        }
                        this.$emit('apprInfo', this.apprInfo)
                        this.loaded = false
                    });
            },
            cancel(docMngNo) {
                this.$swal({
                    type: 'info',
                    text: `상신을 취소합니다. 계속 하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        if (docMngNo != undefined) {
                            this.$http.get(`/api/appr/detail/cancel/${docMngNo}`)
                                .then(response => {
                                    if (response.data) {
                                        this.$swal({type: 'info', text: '상신 취소되었습니다.'});
                                        this.$router.push({path: `/apprReqLst`});
                                    }
                                })
                                .catch(({message}) => {
                                    console.error(message);
                                });
                        }
                    }
                })
            },
            openLinePopup() {
                let vm = this
                this.$modal.open({
                    component: ApprLineSet,
                    props: {
                        lineList: this.apprLine
                    },
                    parent: this,
                    events: {
                        close(data) {
                            // Close event handler
                            vm.apprLine = data.lineList || []
                        }
                    }
                })
            }
        },
        created() {
            if (this.docMngNo !== undefined) this.getAppr(this.docMngNo)
            if (this.docMngNo === undefined) this.queryApprLineRule()
        },
        mounted() {
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.data = value
                }
            },
            approvalLine: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.apprLine = value
                }
            },
            referenceLine: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.referLine = value
                    this.$emit('referenceLine', this.referLine)
                }
            },
            'loaded'() {
                if(this.loaded) this.apprCheck()
            },
        }
    }
</script>

<style scoped>
    .modal-card {
        width: auto;
    }
</style>
